import omit from 'platform/utilities/data/omit';
import {
  titleUI,
  yesNoUI,
  descriptionUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import fullSchema from 'vets-json-schema/dist/21-526EZ-ALLCLAIMS-V2-schema.json';
import {
  ServicePayDescription,
  servicePayYesNoUIHint,
} from '../../components/additionalInformation/servicePay';

import ConfirmationServicePay from '../../components/confirmationFields/ConfirmationServicePay';

const { serviceInformation } = fullSchema.properties;

export const updateFormData = (_oldData, newData) =>
  newData?.serviceInformation?.isReceivingServicePay === false
    ? omit(['view:servicePayType', 'servicePay'], newData)
    : newData;

export default {
  uiSchema: {
    'ui:confirmationField': ConfirmationServicePay,
    ...titleUI('Service pay'),
    ...descriptionUI(ServicePayDescription),
    serviceInformation: {
      isReceivingServicePay: yesNoUI({
        title:
          'Are you receiving service pay now or will you receive it in the future?',
        hint: servicePayYesNoUIHint,
        labels: {
          Y: 'Yes',
          N: 'No',
        },
        uswds: true,
      }),
    },
  },
  schema: {
    type: 'object',
    required: ['serviceInformation'],
    properties: {
      serviceInformation: {
        type: 'object',
        required: ['isReceivingServicePay'],
        properties: {
          isReceivingServicePay:
            serviceInformation.properties.isReceivingServicePay,
        },
      },
    },
  },
};
